export interface PaymentSchedule {
  dueDate: Date
  isPaid: boolean
  amountPaid?: number
  datePaid?: Date
  payMethod?: string
  confirmed: boolean // if payment has been confirmed by admin
}

export interface Installment {
  consumerId: string
  orderId: string
  isApproved: boolean
  term: number
  dueEvery: number
  monthlyPayment: number
  monthsPaid: number
  paymentSchedule: PaymentSchedule[]
}

export const installmentConverter: firebase.firestore.FirestoreDataConverter<Installment> = {
  toFirestore: installment => {
    return {
      consumerId: installment.consumerId,
      orderId: installment.orderId,
      isApproved: installment.isApproved,
      term: installment.term,
      dueEvery: installment.dueEvery,
      monthlyPayment: installment.monthlyPayment,
      monthsPaid: installment.monthsPaid,
      paymentSchedule: installment.paymentSchedule
    }
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)

    const paymentSchedule: PaymentSchedule[] = []
    data.paymentSchedule.forEach((schedule: any) => {
      paymentSchedule.push({
        dueDate: schedule.dueDate.toDate(),
        isPaid: schedule.isPaid,
        amountPaid: schedule.amountPaid ?? undefined,
        datePaid: schedule.datePaid ? schedule.datePaid.toDate() : undefined,
        payMethod: schedule.payMethod ?? undefined,
        confirmed: schedule.confirmed
      })
    })

    return {
      consumerId: data.consumerId,
      orderId: data.orderId,
      isApproved: data.isApproved,
      term: data.term,
      dueEvery: data.dueEvery,
      monthlyPayment: data.monthlyPayment,
      monthsPaid: data.monthsPaid,
      paymentSchedule: paymentSchedule
    }
  }
}
